import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
export const getTopInStockVehiclesBySourceLink = (source, dateRange) => {
    if (source === LeadsDataSource.VIN_SOLUTIONS) {
        return 'https://www.vinsolutions.com';
    }
    return getNvisionAnalyzeLeadsUrl(dateRange, true);
};
export const topStockDataFormatter = (data) => ({
    chartData: ((data || {}).topInStockVehicles || []).map(({ stockNumber, year, make, model, leadCount, }) => ({
        description: `${year} ${make} ${model}: Stock # ${stockNumber}`,
        value: leadCount,
    })),
    lastUpdatedUTC: (data || {}).lastUpdatedUTC || '',
});
